import { components } from "react-select";

export const LoadingMessage = (props) => {
	return (
		<components.LoadingMessage {...props}>
			<span className="custom-css-class">Cargando...</span>
		</components.LoadingMessage>
	);
};
